import script from "./SearchResultPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchResultPanel.vue?vue&type=script&setup=true&lang=js"

import "./SearchResultPanel.vue?vue&type=style&index=0&id=f6b87c72&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6b87c72"]])

export default __exports__